import { css } from '@emotion/react';

export const getStickyScrollCss = () => {
  return css`
    overflow-y: auto;
    background-color: inherit;
  `;
};
